const permissions = {
  group_overview: { ADMIN: true, RESELLER: true, USER: false },
  clients: { ADMIN: false, RESELLER: true, USER: false },
  invoices: { ADMIN: true, RESELLER: false, USER: true },
  reseller_invoices: { ADMIN: false, RESELLER: true, USER: false },
  phone: { ADMIN: false, RESELLER: false, USER: false }
};

export default permissions;
